import React from 'react';
import { useIntl } from 'react-intl';
import { Label } from '@americanexpress/dls-react';
import DropdownButton from '../DropdownButton/DropdownButton';
import { useRoomsContext } from '../../contexts/roomsContext';
import { countTravelersFromRooms } from '../../utils/roomReducerUtil';
import { useConfigContext } from '../../contexts/configContext';
import { bindFunctionValue } from '../../utils/bindFunctionValue';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';

const TravelersRoomButton = React.forwardRef((_, ref) => {
  const {
    rooms,
    tooltipVisible,
    setTooltipVisible,
  } = useRoomsContext();
  const {
    moduleId,
    element,
    hasRooms,
    hasLabel,
  } = useConfigContext();
  const { formatMessage } = useIntl();
  const totalTravelers = countTravelersFromRooms(rooms);
  const isVariant = useIsHomePageVariantHook();
  const label = hasLabel && !isVariant ? formatMessage({ id: 'travelersLabel' }) : '';
  const currentValue = formatMessage({
    id: hasRooms ? 'totalTravelersAndRooms' : 'totalTravelers',
  }, { totalRooms: rooms.length, totalTravelers });
  const dropDownButton = (
    <DropdownButton
      element={element}
      label={label}
      travelers={totalTravelers}
      currentValue={currentValue}
      isPopupOpened={tooltipVisible}
      id={`${moduleId}_popupButton`}
      onClick={bindFunctionValue(!tooltipVisible, setTooltipVisible)}
      ref={ref}
    />
  );

  return (
    isVariant ? (
      <div className="col pad-0">
        <Label id={`${moduleId}_popupButton-label`} className="margin-1-b">
          {hasRooms ? formatMessage({ id: 'room_traveler_label' }) : formatMessage({ id: 'traveler_label' })}
        </Label>
        {dropDownButton}
      </div>
    ) : dropDownButton
  );
});

TravelersRoomButton.displayName = 'TravelersRoomButton';

export default TravelersRoomButton;
